/**
 * Action types for the contest list and the chosen contest
 * @type {Object<string, string>}
 */
const actionTypes = {
  SET_CONTESTS: 'SET_CONTESTS',
  SELECT_CONTEST: 'SELECT_CONTEST'
}

export default actionTypes
